import { useState } from 'react';
import { ParamsManagement } from '../sections/ParamsManagement/ParamsManagement';
import { useAdminToast } from '../shell/AdminToastContext';

export const ParametrosGestoriaPage = () => {
    const toast = useAdminToast();
    const [managementCosts] = useState({});
    const [feesRes] = useState([]);
    const [, setParamsCalcRes] = useState([]);

    return (
        <ParamsManagement
            managementCosts={managementCosts}
            feesRes={feesRes}
            setParamsCalcRes={setParamsCalcRes}
            toast={toast}
        />
    );
};

export default ParametrosGestoriaPage;
